<div class="container"
  [ngClass]="{accessible: accessibilityMode}"
  [attr.data-testid]="'vi-switch-container-' + (title || label || 'default')">
  <button tabindex="0"
    role="switch"
    [title]="title"
    [attr.aria-label]="title"
    [attr.aria-checked]="checked"
    [disabled]="disabled"
    [ngClass]="{on: checked, 'off' : !checked}"
    (viUiAccessibleClick)="onChange()"
    viUiDebounce
    (debounceEvent)="debounceCheckedChange()"
    [debounceEventNames]="['click', 'keyup.enter']"
    [debounceValue]="checked"
    [attr.data-testid]="'vi-switch-' + (title || label || 'default')">
    <span class="circle" [attr.data-testid]="'vi-switch-circle-' + (title || label || 'default')"></span>
  </button>
  @if (label) {
    <label tabindex="-1"
      [for]="labelFor"
      (viUiAccessibleClick)="onChange()"
       viUiDebounce
      (debounceEvent)="debounceCheckedChange()"
      [debounceEventNames]="['click', 'keyup.enter']"
      [debounceValue]="checked"
      [attr.data-testid]="'vi-switch-label-' + (title || label || 'default')">
      {{label}}
    </label>
  }
</div>
